import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { Box, Button } from '@mui/material';

import { ModuleRegistry } from 'ag-grid-community';
import {
  ClientSideRowModelModule,
  MasterDetailModule,
  ClipboardModule,
  ExcelExportModule,
  ColumnMenuModule,
  ContextMenuModule,
  CellSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  RowStyleModule,
  RowSelectionModule,
  SetFilterModule,
  MultiFilterModule,
  GroupFilterModule,
} from 'ag-grid-enterprise';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  MasterDetailModule,
  ClipboardModule,
  ExcelExportModule,
  ColumnMenuModule,
  ContextMenuModule,
  CellSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  RowStyleModule,
  RowSelectionModule,
  SetFilterModule,
  MultiFilterModule,
  GroupFilterModule,
]);

const EstimateHistory = () => {
  const columnDefs = [
    {
      headerName: 'Estimate Name',
      field: 'name',
      cellRenderer: 'agGroupCellRenderer',
      flex: 1,
      cellStyle: { textAlign: 'left' },
    },
    {
      headerName: 'Asset',
      field: 'asset',
      width: 150,
      cellStyle: { textAlign: 'left' },
    },
  ];

  const versionColumnDefs = [
    {
      headerName: 'Actions',
      field: 'actions',
      width: 0,
      cellRendererFramework: (params) => (
        <Button variant="contained" size="small" onClick={() => alert(`Viewing version ${params.data.version}`)}>
          View
        </Button>
      ),
    },
    { headerName: 'Name', field: 'name', flex: 1, cellStyle: { textAlign: 'left' } },
    { headerName: 'Version', field: 'version', width: 100, cellStyle: { textAlign: 'left' } },
    { headerName: 'Asset', field: 'asset', width: 120, cellStyle: { textAlign: 'left' } },
    { headerName: 'Diameter', field: 'diameter', width: 120, cellStyle: { textAlign: 'left' } },
    { headerName: 'Length (mi)', field: 'length', width: 120, cellStyle: { textAlign: 'left' } },
    {
      headerName: 'Base',
      field: 'base',
      width: 160,
      valueFormatter: formatCurrency,
      cellStyle: { textAlign: 'left' },
    },
    {
      headerName: 'Contingency',
      field: 'contingency',
      width: 160,
      valueFormatter: formatCurrency,
      cellStyle: { textAlign: 'left' },
    },
    {
      headerName: 'Budget',
      field: 'budget',
      width: 180,
      valueFormatter: formatCurrency,
      cellStyle: { textAlign: 'left' },
    },
    {
      headerName: '$/in-mile',
      field: 'perInchMile',
      width: 140,
      valueFormatter: formatCurrency,
      cellStyle: { textAlign: 'left' },
    },
  ];

  const rowData = [
    {
      name: 'Eiger Mainline',
      asset: 'Eiger',
      versions: [
        {
          name: 'Eiger Mainline',
          version: 1,
          asset: 'Eiger',
          diameter: 42,
          length: 403,
          base: 1543842593,
          contingency: 72031826,
          budget: 1615874419,
          perInchMile: 95550,
        },
        {
          name: 'Eiger Mainline',
          version: 2,
          asset: 'Eiger',
          diameter: 42,
          length: 403,
          base: 1497842593,
          contingency: 74892130,
          budget: 1572734722,
          perInchMile: 92918,
        },
      ],
    },
    {
      name: 'Denali Extension',
      asset: 'Denali',
      versions: [
        {
          name: 'Denali Extension',
          version: 1,
          asset: 'Denali',
          diameter: 36,
          length: 250,
          base: 1123842593,
          contingency: 65231826,
          budget: 1189074419,
          perInchMile: 84500,
        },
      ],
    },
  ];

  function formatCurrency(params) {
    return params.value?.toLocaleString('en-US');
  }

  return (
    <Box sx={{ padding: 2 }}>
      <div style={{ width: '100%', height: 600 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          masterDetail={true}
          isRowMaster={(dataItem) => !!dataItem.versions?.length}
          detailCellRendererParams={{
            detailGridOptions: {
              columnDefs: versionColumnDefs,
              domLayout: 'autoHeight',
              defaultColDef: {
                flex: 1,
                minWidth: 100,
                resizable: true,
              },
            },
            getDetailRowData: (params) => {
              const sortedVersions = [...params.data.versions].sort((a, b) => b.version - a.version);
              params.successCallback(sortedVersions);
            },
          }}
          defaultColDef={{
            flex: 1,
            resizable: true,
          }}
        />
      </div>
    </Box>
  );
};

export default EstimateHistory;
